import React from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';

import LabImage from '../../images/upsell/LabPlaceholder.svg';
import ReportTat from '../../images/upsell/ReportTat.svg';
import ParameterPlaceholder from '../../images/upsell/Parameter.svg';
import HomeCenter from '../../images/upsell/HomeCollection.svg';
import { logEvent } from '../../utils/logEvent';

const CardDiv = styled.div`
  box-shadow: 0px 1px 10px 0px #0000001a;
  min-width: ${(props) => (props.totalCards > 1 ? '80%' : '90%')};
  border-radius: 20px;
`;
const Chip = styled.div`
  background: linear-gradient(180deg, #ff857a 0%, #ff626f 100%);
  font-family: Inter;
  font-weight: 700;
  font-size: 12px;
  line-height: 100%;
  letter-spacing: 0px;
  text-align: center;
  color: #ffffff;
  width: fit-content;
  padding: 2px 12px;
  border-radius: 20px 0px 20px 0px;
`;
const CardHeader = styled.div`
  background: linear-gradient(276.59deg, #fefbf5 -37.26%, #fdedd6 161.23%);
  border: 1px solid #fdedd6;
  border-radius: 20px;
`;
const LabDetails = styled.div`
  background: #fafafa;
  padding: 8px 16px;
  margin: 12px 16px;
  border-radius: 8px;
`;

export default function UpSellCard({
  cardData,
  totalCards,
  onViewDetails,
  onBookNow,
  isLoading,
  loadingCta,
}) {
  const history = useHistory();
  return (
    <CardDiv totalCards={totalCards}>
      <CardHeader>
        <Chip>upto 70% OFF</Chip>
        <div className="pr-8px py-16px pl-24px">
          <div className="font-bold text-title-m text-txtlight">
            {cardData?.packageName}
          </div>
          <div className="font-medium text-body-s text-txtsecondary">
            {cardData?.packageInvestigation}
          </div>
        </div>
      </CardHeader>
      <LabDetails>
        <div className="flex items-center gap-4px">
          <img src={LabImage} alt="lab" />
          <div className="text-body-s">{cardData?.partnerName}</div>
          <div
            style={{
              background: '#ffffff',
              border: '1px solid #F2F2F3',
              borderRadius: '10px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              padding: '6px',
            }}
          >
            <img
              src={cardData?.partnerImageUrl}
              alt="partner"
              style={{ maxWidth: '52px', maxHeight: '20px' }}
            />
          </div>
        </div>
        <div className="flex items-center justify-between mt-12px">
          <div className="flex items-center gap-4px">
            <img src={ReportTat} alt="lab" />
            <div className="text-body-s">Reports in 12 hrs</div>
          </div>
          <div className="flex items-center gap-4px">
            <img src={ParameterPlaceholder} alt="parameter" />
            <div
              className="text-body-s"
              style={{
                borderBottom: '1px solid #551EE3',
                borderStyle: 'dashed',
                color: '#551EE3',
              }}
            >
              {cardData?.packageTestCount} Parameters
            </div>
          </div>
        </div>
      </LabDetails>
      <div
        className="mx-16px pt-12px"
        style={{
          borderTop: '1px solid #D8D7DB',
          borderStyle: 'dashed',
        }}
      >
        <div className="flex items-start gap-4px justify-between">
          <div className="flex items-center gap-4px">
            <img src={HomeCenter} alt="home-collection" />
            <div className="text-body-l text-txtlight font-medium">
              Home Collection
            </div>
          </div>
          <div className="flex items-center gap-4px">
            <div className="text-txtlight font-bold text-title-m2">
              ₹{cardData?.offerPrice}
            </div>
            <div className="text-txtsecondary font-bold text-body-l line-through">
              ₹{cardData?.packageMrp}
            </div>
          </div>
        </div>
      </div>
      <div className="flex items-center justify-between mt-12px mx-16px gap-12px pb-16px">
        <div
          className="border border-primary py-8px px-8px text-center text-primary rounded-12 w-full font-semibold text-body-l cursor-pointer"
          style={
            isLoading
              ? { opacity: 0.7, pointerEvents: 'none', userSelect: 'none' }
              : {}
          }
          onClick={() => {
            // logEvent('AHC Upsell View Details Tapped', {
            //   packageId: cardData.packageId,
            //   packageName: cardData.packageName,
            // });
            if (onViewDetails) {
              onViewDetails(cardData);
            } else {
              history.push('/ahc-upsell/package-details', {
                packageId: cardData?.packageId,
                partnerId: cardData?.partnerId,
              });
            }
          }}
        >
          {isLoading && loadingCta === 'details'
            ? 'Loading...'
            : 'View Details'}
        </div>
        <div
          className="bg-primary py-10px px-8px text-center text-textbox rounded-12 w-full font-semibold text-body-l cursor-pointer"
          style={
            isLoading
              ? { opacity: 0.7, pointerEvents: 'none', userSelect: 'none' }
              : {}
          }
          onClick={() => {
            // logEvent('AHC Upsell Book Now Tapped', {
            //   packageId: cardData.packageId,
            //   packageName: cardData.packageName,
            // });
            if (onBookNow) {
              onBookNow(cardData);
            }
          }}
        >
          {isLoading && loadingCta === 'book' ? 'Loading...' : 'Book Now'}
        </div>
      </div>
    </CardDiv>
  );
}
